import { useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import UserDetailsService from '../../shared/services/user-details/user-details.service';
import OrganisationService from '../../shared/services/organisation/organisation.service';
import { IUserDetails } from '../../shared/services/user-details/user-details.model';
import { IOrganisationDetails } from '../../shared/services/organisation/organisation.model';

export const HomePage = (props: any) => {

  // const userDetailsService = new UserDetailsService();
  // const organisationService = new OrganisationService();

  // const [user, setUser] = useState<IUserDetails>();
  // const [organisations, setOrganisations] = useState<IOrganisationDetails[]>();
  // const match = useMatch('/home')

  const navigate = useNavigate();

  useEffect(() => {
    navigate('/login')
  }, [])


  // useEffect(() => {

  //   organisationService.getOrganisations()
  //     .then(response => {
  //       setOrganisations(response);
  //       console.log(response)
  //     })
  //     .catch(err => {
  //       console.log(err)
  //     })
  // }, [])



  return (
    // <p>This is the home page</p>
    <></>
  )
}